<template>
  <PermissionsByDevice v-if="permissionsByDeviceDialog"
    :userData="userData"
    :permissionsByDeviceDialog.sync="permissionsByDeviceDialog"
  />
  <v-row v-else class="general-permissions custom-scroll-bar">
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      top
      :color="snackbarColor"
      rounded
      centered
    >
      {{ snackbarText }}
    </v-snackbar>
    <Dialog
      :dialog.sync="permissionChangeDialog"
      :cardText="dialogCardText"
      :mainBtnText="dialogMainText"
      :secondaryBtnText="dialogSecondaryText"
      @mainBtnCallback="permissionChangeDialogMain"
      @secondaryBtnCallback="permissionChangeDialogSecondary"
    />
    <Dialog
      :dialog.sync="confirmPermissionChangeDialog"
      :cardText="dialogCardText"
      :mainBtnText="dialogMainText"
      :secondaryBtnText="dialogSecondaryText"
      @mainBtnCallback="confirmPermissionChangeDialogMain"
      @secondaryBtnCallback="confirmPermissionChangeDialogSecondary"
    />
    <v-col cols="2" class="profile-pic-col">
      <v-img class="profile-pic" id="profile-pic" height="124" width="124" :src="profilePicSrc"/>
    </v-col>
    <v-col cols="9" offset="1">
      <v-row no-gutters>
        <v-col cols="12">
          <p class="section-text text-left">{{$t('GeneralPermissions.permissions')}}</p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col v-for="perm in Object.keys(permissions)" :key="`switch_${perm}`">
          <v-row class="permissions-elements flex-nowrap">
            <v-switch
              @click="permissionChanged(perm)"
              v-model="permissions[perm]"
              inset
              color="#00D166"
              :disabled="userData.permissionsCustomized"
            />
            <p class="mb-0 text-start switch-text">{{$t(`UsersPermissions.${perm}`)}}</p>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-5">
        <v-col cols="12" class="text-left">
          <a @click="viewPermissionsByDevice" class="clickable-text">{{$t('GeneralPermissions.viewPermissionsByDevice')}}</a>
        </v-col>
      </v-row>

      <v-row no-gutters class="pt-10">
        <v-col cols="12">
          <p class="section-text text-left">{{$t('GeneralPermissions.channels')}}</p>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="3">
          <v-row class="permissions-elements flex-nowrap">
            <v-switch
              @click="changeChannel('push')"
              v-model="pushChannel"
              inset
              color="#00D166"
            />
            <p class="mb-0 text-start switch-text">{{$t('GeneralPermissions.push')}}</p>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row class="permissions-elements flex-nowrap">
            <v-switch
              @click="changeChannel('whatsapp')"
              v-model="whatsappChannel"
              inset
              color="#00D166"
            />
            <p class="mb-0 text-start switch-text">{{$t('GeneralPermissions.whatsapp')}}</p>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row class="permissions-elements flex-nowrap">
            <v-switch
              @click="changeChannel('sms')"
              v-model="smsChannel"
              inset
              color="#00D166"
            />
            <p class="mb-0 text-start switch-text">{{$t('GeneralPermissions.sms')}}</p>
          </v-row>
        </v-col>
      </v-row>

      <!--
      <v-row no-gutters class="pt-10">
        <v-col cols="12">
          <p class="section-text text-left">{{$t('GeneralPermissions.alertPeriod')}}</p>
        </v-col>
      </v-row>
      -->

      <v-row no-gutters class="pt-3">
        <!--
        <v-col cols="2">
          <v-text-field
            v-model="startHour"
            outlined
            :label="$t('GeneralPermissions.startHour')"
            type="time"
            background-color="#FFF"
            color="#0098E1"
            validate-on-blur
            hide-details
            required
          />
        </v-col>
        <v-col cols="2" offset="1">
          <v-text-field
            v-model="endHour"
            outlined
            :label="$t('GeneralPermissions.endHour')"
            type="time"
            background-color="#FFF"
            color="#0098E1"
            validate-on-blur
            hide-details
            required
          />
        </v-col>
        -->
        <v-col cols="2" offset="4">
          <v-btn
            @click="save"
            block
            color="#0098E1"
            large
            class="text-none text-h6 font-weight-light"
            dark
          >{{$t('GeneralPermissions.save')}}</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import get from 'lodash/get'
  import Dialog from '../../Shared/Dialog'
  import PermissionsByDevice from './PermissionsByDevice.vue'
  import {updateUsersNotificationsPermissions} from '../../../lib/crudOperations/write'

  export default {
    props: {
      userData: {
        type: Object,
        required: true
      }
    },
    components: {
      Dialog,
      PermissionsByDevice
    },
    data () {
      return {
        profilePicSrc: null,
        permissions: {
          // Uncomment to show these permissions
          // failure: false,
          // pressure: false,
          // off: false,
          // position: false,
          reports: this.userData.reports || false
        },
        whatsappChannel: this.userData.channels.includes('whatsapp'),
        smsChannel: this.userData.channels.includes('sms'),
        pushChannel: this.userData.channels.includes('push'),
        startHour: get(this.userData, 'settings.notificationsPeriod.startHour', '00:00'),
        endHour: get(this.userData, 'settings.notificationsPeriod.endHour', '23:59'),
        snackbar: false,
        snackbarTimeout: 3000,
        snackbarText: '',
        snackbarColor: '',
        permissionChangeDialog: false,
        confirmPermissionChangeDialog: false,
        dialogCardText: '',
        dialogMainText: '',
        dialogSecondaryText: '',
        permissionsByDeviceDialog: false,
        dialogSelectedPermission: '',
        usersToUpdatePermissions: []
      }
    },
    created () {
      this.setUserImg()
    },
    methods: {
      setUserImg () {
        if (this.userData.photoUrl) {
          this.profilePicSrc = this.userData.profilePic
        } else {
          switch (this.userData.role) {
            case 'admin':
            case 'owner':
              this.profilePicSrc = require('../../../assets/owner.png')
              break
            case 'manager':
              this.profilePicSrc = require('../../../assets/manager.png')
              break
            case 'fieldman':
              this.profilePicSrc = require('../../../assets/fieldman.png')
              break
            case 'farmhand':
              this.profilePicSrc = require('../../../assets/farmhand.png')
              break
          }
        }
      },
      changeChannel (channel) {
        const newChannels = this.userData.channels
        let channelIndex
        let channelFlag
        switch (channel) {
          case 'whatsapp':
            channelFlag = this.whatsappChannel
            break
          case 'sms':
            channelFlag = this.smsChannel
            break
          case 'push':
            channelFlag = this.pushChannel
            break
        }
        if (channelFlag && !this.userData.channels.includes(channel)) {
          newChannels.push(channel)
          this.$emit('update:userData', {
            ...this.userData,
            channels: newChannels
          })
        } else if (!channelFlag && this.userData.channels.includes(channel)) {
          channelIndex = this.userData.channels.findIndex(elem => elem === channel)
          newChannels.splice(channelIndex, 1)
          this.$emit('update:userData', {
            ...this.userData,
            channels: newChannels
          })
        }
      },
      viewPermissionsByDevice () {
        if (!this.userData.devices.length) {
          this.snackbar = true
          this.snackbarText = this.$t('GeneralPermissions.noDevicesAlert')
          this.snackbarColor = '#F93A2F'
        } else {
          this.permissionsByDeviceDialog = true
        }
      },
      save () {
        this.$emit('update:generalPermissionsDialog', false)
        this.$emit('update:userData', {
          ...this.userData,
          failuresPermission: this.permissions.failure,
          pressurePermission: this.permissions.pressure,
          offPermission: this.permissions.off,
          positionPermission: this.permissions.position,
          reports: this.permissions.reports,
          settings: {
            ...this.userData.settings,
            notificationsPeriod: {
              startHour: this.startHour,
              endHour: this.endHour
            }
          }
        })
      },
      permissionChanged (perm) {
        this.dialogSelectedPermission = perm
        this.usersToUpdatePermissions = [this.userData]
        this.permissionChangeDialog = true
        this.dialogCardText = this.$t('GeneralPermissions.permissionChangedText', [this.userData.name, this.$t(`Roles.${this.userData.role}s`)])
        this.dialogMainText = this.$t('GeneralPermissions.permissionChangeMainBtn', [this.$t(`Roles.${this.userData.role}s`)])
        this.dialogSecondaryText = this.$t('GeneralPermissions.permissionChangeSecondaryBtn')
      },

      permissionChangeDialogMain () {
        let usersWithPermissionDiff = []

        if (this.dialogSelectedPermission === 'reports') {
          usersWithPermissionDiff = this.$store.getters.organizationUsers.filter(u => {
            return u.id !== this.userData.id && u.role === this.userData.role && u.reports !== this.permissions[this.dialogSelectedPermission]
          })
          this.usersToUpdatePermissions = [...this.usersToUpdatePermissions, ...usersWithPermissionDiff]
        } else {
          const sameRoleUsers = this.$store.getters.organizationUsers.filter(u => u.id !== this.userData.id && u.role === this.userData.role)
          usersWithPermissionDiff = sameRoleUsers.filter(user => {
            const ownDevices = this.$store.getters.devices.filter(dev => user.devices && user.devices.includes(dev.id))
            let permDiff = false
            let i = 0

            while (!permDiff && i < ownDevices.length) {
              const notiData = ownDevices[i].notifications.find(noti => noti.id === user.id)
              if (notiData) {
                permDiff = notiData.permissions[this.dialogSelectedPermission] !== this.permissions[this.dialogSelectedPermission]
              }
              i++
            }
            return permDiff
          })
        }

        this.usersToUpdatePermissions = [...this.usersToUpdatePermissions, ...usersWithPermissionDiff]
        this.confirmPermissionChangeDialog = true
        this.dialogCardText = this.$t('GeneralPermissions.confirmPermissionChangedText', [usersWithPermissionDiff.map(u => u.name).join(', ')])
        this.dialogMainText = this.$t('GeneralPermissions.confirmPermissionChangeMainBtn', [this.userData.name])
        this.dialogSecondaryText = this.$t('GeneralPermissions.confirmPermissionChangeSecondaryBtn')
      },
      permissionChangeDialogSecondary () {
        this.updateUsersPermissionsHandler([this.usersToUpdatePermissions[0]])
      },
      confirmPermissionChangeDialogMain () {
        this.updateUsersPermissionsHandler([this.usersToUpdatePermissions[0]])
      },
      confirmPermissionChangeDialogSecondary () {
        this.updateUsersPermissionsHandler(this.usersToUpdatePermissions)
      },
      async updateUsersPermissionsHandler (users) {
        try {
          await updateUsersNotificationsPermissions(users, this.dialogSelectedPermission, this.permissions[this.dialogSelectedPermission])
          this.$root.snack.show({text: this.$t('UI.registerSuccess')})
          this.$emit('update:generalPermissionsDialog', false)
        } catch (err) {
          this.$root.snack.show({text: this.$t('UI.registerError'), error: true})
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// GeneralPermissions.vue?72a7bfaa